import BttfAxios from '@features/utils/axios';

export enum AgreementType {
  StepThree = 'bitcoin_journey_step_three',
  StepFive = 'bitcoin_journey_step_five',
}

const BitcoinJourneyService = {
  acceptAgreement: async (agreementType: AgreementType) =>
    await BttfAxios.post('/api/bitcoin_journey_user_agreements/accept', {agreement_type: agreementType}, resp => resp),

};

Object.freeze(BitcoinJourneyService);
export default BitcoinJourneyService;
